import { useFormContext } from "../../utils/FormContext.jsx";
import InfoSVG from "../../assets/InfoSVG.jsx";
import InfoModal from '../InfoModal.jsx'; 
import { useState } from "react";
import DatesInfoModalContent from "../../utils/DatesInfoModalContent.jsx";
import { useMediaQuery } from 'react-responsive';

const DatesSubsection = ({ subSection, handleFillField, filled, formData }) => {
    const { handleDateInputChange } = useFormContext(); 
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    
    const dateContent = DatesInfoModalContent.find((item) => item.title === subSection.title); 

    // ADDED CODE TO FIX CAPITALIZATION ISSUE
    const normalizedTitle = subSection.title.replaceAll(' ', '_').toLowerCase();

    const dateValue = formData.dateFields[normalizedTitle]?.date || '';
    const daysFromMEC = formData.dateFields[normalizedTitle]?.daysFromMEC || '';
    let inputType = subSection.inputType || "date";
    // let dayOfWeek = ''; 

    if (dateValue === 'N/A') {
        inputType = "text";
    } 

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
        // dateContent; 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    }

    const handleDateFieldInputChange = (event) => {
        const value = event.target.value; 
        const isFilled = value !== '';
        handleFillField(isFilled);
        
        handleDateInputChange({
            target: {
                name: normalizedTitle, 
                value: value
            }
        });
    };
    
    const handleNumberInput = (event) => {
        const value = event.target.value;
        if (!/^\d*$/.test(value)) {
            event.preventDefault();
        }
    };

    return (
        <div>
            <div className={`w-[375px] md:w-full self-stretch px-[15px] py-2.5 border-b border-black bg-slate-100 justify-between items-center inline-flex`}>
                <div className={`text-[13px] md:text-base font-['Inter'] w-[150px] md:w-[275px] ml-2 md:ml-5 text-black`}>{subSection.title}</div>
                <div className="h-11 justify-center md:justify-end items-center gap-[15px] md:gap-[25px] flex">
                    <InfoSVG onClick={handleInfoClick} width={18} height={18}/>
                    <div className={`${isMobile ? 'w-[150px] px-[1px]' : 'w-[290px] px-[33px]'} flex-col items-center gap-10 flex`}>
                    {inputType === "date" ? (
                        <div className="flex items-center border border-black rounded-lg py-1 px-3 h-[39px] w-full">
                            <input 
                                type={normalizedTitle.includes('time') ? "text" : "number"}
                                className="w-[35px] md:w-[50px] text-[12px] md:text-[16px] text-shi-green font-normal"
                                value={daysFromMEC}
                                placeholder="___"
                                onChange={handleDateFieldInputChange}
                                onInput={normalizedTitle.includes('time') ? undefined : handleNumberInput}
                                pattern={normalizedTitle.includes('time') ? undefined : "\d*"}
                            />
                            <span className="ml-2 text-[12px] md:text-[14px] text-shi-green">
                                {normalizedTitle === 'acceptance_deadline_date' ? 'day from Receiving Contract' : 'days from MEC'}
                            </span>
                        </div>
                    ) : (
                        <input 
                            type={normalizedTitle.includes('time') ? "text" : "number"}
                            className={`py-1 px-3 h-[39px] rounded-lg border border-black w-full text-[12px] md:text-[16px] text-shi-green ${filled ? 'font-semibold bg-slate-100' : 'font-normal'}`} 
                            value={daysFromMEC || dateValue}
                            placeholder={(normalizedTitle === 'time_deadline_to_send_contract' || normalizedTitle === 'possession_time' || normalizedTitle === 'acceptance_deadline_time') ? 'hh:mm AM/PM' : '___ days from MEC'}
                            onChange={handleDateFieldInputChange}
                            onInput={normalizedTitle.includes('time') ? undefined : handleNumberInput}
                            pattern={normalizedTitle.includes('time') ? undefined : "\d*"}
                        />
                    )}
                    </div>
                </div>
            </div>
            <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-[16px] md:text-2xl font-bold mb-1 md:mb-4">{dateContent.title}</h1>
                    {isMobile ? '' : <hr className="my-4" />}
                    <p className="text-[14px] md:text-[16px]">{dateContent.content}</p>
                    {dateContent.mecDate && (
                    <div className="w-full flex justify-center items-center">
                        <div className="border-shi-green border-2 bg-slate-800 w-[235px] md:w-[300px] h-[40px] md:h-[48px] mt-4 items-center flex justify-center">
                            <p className="text-white items-center text-[14px] md:text-[16px] px-2">{dateContent.mecDate}</p>
                        </div>
                    </div>
                    )}
                </div>
            </InfoModal>
        </div>
    );
}

export default DatesSubsection;